import { createShallowStore, createStore } from '@frontend/store';

interface ScheduleBookingRequestsStore {
  combineBookingRequests: boolean;
  setCombineBookingRequests: (value: boolean) => void;
}

const useScheduleBookingRequestsStore = createStore<ScheduleBookingRequestsStore>(
  (set) => ({
    combineBookingRequests: false, // flag used to combine booking requests from v2 and v3 APIs
    setCombineBookingRequests: (value) => set({ combineBookingRequests: value }),
  }),
  { name: 'schedule-booking-requests-store' }
);

export const useScheduleBookingRequestsShallowStore = createShallowStore<ScheduleBookingRequestsStore>(
  useScheduleBookingRequestsStore
);
